import * as React from 'react';
import { IPermissionOption, ISelectOption, IUser } from '../../../data/types';
import { TextField } from '../../shared/form/TextField';
import { ControlSpacer } from '../../shared/form/ControlSpacer';
import { FormContainer } from '../../shared/form/FormContainer';
import { PermissionsSelect } from '../../shared/form/selects/PermissionsSelect';
import { TeamSelect } from '../../shared/form/selects/TeamSelect';
import { ControlLabel } from '../../shared/form/ControlLabel';
import styled from 'styled-components';

interface IProps {
  email?: string;
  setEmail: (e: string) => void;
  setPermission: (p: IPermissionOption) => void;
  permission?: IPermissionOption;
  name?: string;
  setName: (n: string) => void;
  team?: ISelectOption;
  setTeam: (t: ISelectOption) => void;
  requestingUser: IUser;
}

export const UserForm = (props: IProps): React.ReactElement => {
  return (
    <FormContainer>
      <ControlSpacer>
        <TextField
          name='name'
          value={props.name ?? ''}
          label='Name'
          type='text'
          onChange={props.setName}
        />
      </ControlSpacer>
      <ControlSpacer>
        <TextField
          name='email'
          value={props.email ?? ''}
          label='Email'
          type='text'
          onChange={props.setEmail}
        />
      </ControlSpacer>
      <ControlSpacer>
        <ControlLabel>Select Team</ControlLabel>
        <TeamSelect
          value={props.team}
          onChange={props.setTeam}
          allowedTeams={
            props.requestingUser.claims?.orgAdmin
              ? null
              : props.requestingUser?.adminOf
          }
        />
      </ControlSpacer>
      <ControlSpacer>
        <PermissionsSelect
          teamId={props.team?.value}
          value={props.permission}
          onChange={props.setPermission}
        />
      </ControlSpacer>

      {props.permission?.value ? (
        props.permission?.value?.write === true ? (
          <TeamAdminDescription />
        ) : (
          <TeamUserDescription />
        )
      ) : null}
    </FormContainer>
  );
};

const TeamAdminDescription = (): React.ReactElement => {
  return (
    <DescriptionWrapper>
      A Team Administrator can access this team's data and can add or remove
      other users from this team.
    </DescriptionWrapper>
  );
};

const TeamUserDescription = (): React.ReactElement => {
  return (
    <DescriptionWrapper>
      A Team User can access this team's data but cannot add or remove other
      users from this team.
    </DescriptionWrapper>
  );
};

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 25px;
`;
